import { render, staticRenderFns } from "./CBAVJKIK.vue?vue&type=template&id=3728cf20&scoped=true"
import script from "./CBAVJKIK.vue?vue&type=script&lang=js"
export * from "./CBAVJKIK.vue?vue&type=script&lang=js"
import style0 from "./CBAVJKIK.vue?vue&type=style&index=0&id=3728cf20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3728cf20",
  null
  
)

export default component.exports